<!--
    @file:主页的menu页面,根据menu.json文件来展示对应menu模块
-->
<template>
    <div id="main">
        <el-row>
            <el-col :xs="24" :sm="12" :md="6" v-for="menu in menus" :key="menu.id">
                <div class="card">
                    <h4><img :src="menu.ico"/><br/>{{ menu.menu }}</h4>
                    <el-col :span="12" v-for="item in menu.items" :key="item.id">
                        <router-link :to="{ path: item.path }" >{{ item.name }}</router-link>
                    </el-col>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: 'main',
    created () {
        this.getMenuData();
    },
    data () {
        return {
            menus: []
        };
    },
    methods: {
        getMenuData () {
            /**
             * 获取所要展现的模块信息
             *
             */
            var self = this;
            this.$ajax({
                method: 'get',
                url: self.Api.menu
            }).then(function (res) {
                if (res.status === 200) {
                    self.menus = res.data;
                }
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#main {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    background-color:#e3e8f2;
    background-image:url(../assets/img/mainbg_decoration.png),url(../assets/img/mainbg_bottom.png);
    background-repeat: no-repeat;
    background-position: top center, bottom center;
    background-size: 100% auto;
    background-attachment: fixed;
}
#main .el-row{
    max-width:1500px;
    margin:0 auto !important;
    padding:10px;
}
.card{
    height: 280px;
    margin: 10px;
    padding: 1px 0;
    background:#fff;
    box-shadow:0 0 10px #bec7d3,0 0 10px #bec7d3;
}
.card:hover{
    box-shadow:0 0 20px #bec7d3,0 0 20px #bec7d3;
}
.card h4{
    font-size:18px;
    color:#5182e4;
}
.card a{
    font-size:13px;
    color:#999;
    display:inline-block;
    border-bottom:2px solid #ccc;
    text-decoration:none;
    white-space: nowrap;
    margin-bottom:10px;
}
.card a:hover{
    color:#5182e4;
    border-color:#5182e4;
}
@media screen and (min-width: 960px) {
    #home .el-row{
        padding:25px 50px;
    }
    .card{
        margin: 25px;
    }
}
</style>



// WEBPACK FOOTER //
// main.vue?67679bcf